import * as Yup from 'yup'

export const changePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .required('Old password is required')
    .min(6, 'Password must be at least 6 characters long'),
  newPassword: Yup.string()
    .required('New password is required')
    .min(6, 'Password must be at least 6 characters long')
    .notOneOf(
      [Yup.ref('oldPassword'), null],
      'New password must be different from old password'
    ),
})



